module.exports = __webpack_public_path__ + "img/background.268d8c4e.png";